/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dropwinnersconfirmtitle3Inputs */

const en_dropwinnersconfirmtitle3 = /** @type {(inputs: Dropwinnersconfirmtitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send to ${i?.count} winners?`)
};

const de_dropwinnersconfirmtitle3 = /** @type {(inputs: Dropwinnersconfirmtitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An ${i?.count} Gewinner senden?`)
};

/**
* | output |
* | --- |
* | "Send to {count} winners?" |
*
* @param {Dropwinnersconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersconfirmtitle3 = /** @type {((inputs: Dropwinnersconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersconfirmtitle3(inputs)
	return de_dropwinnersconfirmtitle3(inputs)
});
export { dropwinnersconfirmtitle3 as "dropWinnersConfirmTitle" }